import React from 'react';

export function LoadingPopupComponent({ visible, title, subTitle, icon }) {
    if (!visible) return null;
    return (
        <div className="page-loading-backdrop">
            <div className="page-loading-popup">
                <div className="page-loading-popup-icon">
                    <i className={icon || 'fas fa-circle-notch fa-spin'}></i>
                </div>
                <div className="page-loading-popup-body">
                    <p className="page-loading-popup-title">{title || 'Loading'}</p>
                    {subTitle && <p className="page-loading-popup-sub">{subTitle}</p>}
                </div>
            </div>
        </div>
    );
}
